import http from './../../../core/services/http.service'

export default {
  updateUserData(id, data) {
    return http.put(`/api/v1/users/profile/${id}/`, data);
  },
  getActiveSessions() {
    return http.get(`/api/v1/users/sessions/`);
  },
  getTrustedDevices() {
    return http.get(`/api/v1/users/trusted-devices/`);
  },
  deleteSessions(device) {
    return http.delete(`/api/v1/users/sessions/`, {data: {device}});
  },
  getAuthenticatorData() {
    return http.get(`/api/v1/users/otp/`);
  },
  postAuthenticator(code) {
    const data = {};
    if (code) {
      data['token'] = code
    }
    return http.post(`/api/v1/users/otp/`, {...data});
  },
  removeAuthenticator() {
    return http.delete(`/api/v1/users/otp/`);
  },
  removeTrustedDevice(uuid) {
    return http.delete(`/api/v1/users/trusted-devices/${uuid}/`);
  }
}
